import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const compensationApi = {
  // Grades
  listGrades: () => api.get('/compensation/grades').then(unwrap),
  createGrade: (payload) => api.post('/compensation/grades', payload).then(unwrap),
  updateGrade: (id, patch) => api.patch(`/compensation/grades/${id}`, patch).then(unwrap),
  deleteGrade: (id) => api.delete(`/compensation/grades/${id}`).then(unwrap),

  // Bands
  listBands: (params) => api.get('/compensation/bands', { params }).then(unwrap),
  createBand: (payload) => api.post('/compensation/bands', payload).then(unwrap),
  updateBand: (id, patch) => api.patch(`/compensation/bands/${id}`, patch).then(unwrap),
  deleteBand: (id) => api.delete(`/compensation/bands/${id}`).then(unwrap),
  compaRatio: (id, salary) => api.get(`/compensation/bands/${id}/compa-ratio`, { params: { salary } }).then(unwrap),

  // Plans
  listPlans: (params) => api.get('/compensation/plans', { params }).then(unwrap),
  getPlan: (id) => api.get(`/compensation/plans/${id}`).then(unwrap),
  createPlan: (payload) => api.post('/compensation/plans', payload).then(unwrap),
  updatePlan: (id, patch) => api.patch(`/compensation/plans/${id}`, patch).then(unwrap),
  deletePlan: (id) => api.delete(`/compensation/plans/${id}`).then(unwrap),
  evaluatePlan: (id, payload) => api.post(`/compensation/plans/${id}/evaluate`, payload).then(unwrap),

  // Cycles
  listCycles: (params) => api.get('/compensation/cycles', { params }).then(unwrap),
  getCycle: (id) => api.get(`/compensation/cycles/${id}`).then(unwrap),
  createCycle: (payload) => api.post('/compensation/cycles', payload).then(unwrap),
  updateCycle: (id, patch) => api.patch(`/compensation/cycles/${id}`, patch).then(unwrap),
  openCycle: (id) => api.put(`/compensation/cycles/${id}/open`).then(unwrap),
  closeCycle: (id) => api.put(`/compensation/cycles/${id}/close`).then(unwrap),
  listParticipants: (id) => api.get(`/compensation/cycles/${id}/participants`).then(unwrap),
  getBudget: (id) => api.get(`/compensation/cycles/${id}/budget`).then(unwrap),

  // Participants (worksheet)
  proposeParticipant: (id, payload) => api.put(`/compensation/cycle-participants/${id}`, payload).then(unwrap),
  submitParticipant: (id) => api.put(`/compensation/cycle-participants/${id}/submit`).then(unwrap),

  // Awards
  listAwards: (params) => api.get('/compensation/awards', { params }).then(unwrap),
  getAward: (id) => api.get(`/compensation/awards/${id}`).then(unwrap),
  createAward: (payload) => api.post('/compensation/awards', payload).then(unwrap),
  submitAward: (id) => api.put(`/compensation/awards/${id}/submit`).then(unwrap),
  approveAward: (id) => api.put(`/compensation/awards/${id}/approve`).then(unwrap),
  rejectAward: (id) => api.put(`/compensation/awards/${id}/reject`).then(unwrap),

  // Statements
  listStatements: (params) => api.get('/compensation/statements', { params }).then(unwrap),
  getStatement: (id) => api.get(`/compensation/statements/${id}`).then(unwrap),
  createStatement: (payload) => api.post('/compensation/statements', payload).then(unwrap),
};
